import vouchersAndTicketsModalTemplate from '../views/invoice-actions/vouchers-and-tickets-modal.tpl.html';

class InvoiceActionsService {
    constructor($uibModal, FileSaver, $http) {
        this.modal = $uibModal;
        this.fileSaver = FileSaver;
        this.api = $http;
    }

    startVouchersAndTicketsModal(invoice) {
        return this.modal.open({
            controller: 'VouchersAndTicketsModalController',
            controllerAs: 'vm',
            size: 'lg',
            templateUrl: vouchersAndTicketsModalTemplate,
            resolve: {
                invoiceId() {
                    return invoice.id;
                }
            }
        }).result;
    }

    downloadVouchersOverviewDocument(invoice) {
        return this.api.get(`vouchers/overview-document/invoice/${invoice.id}`, {
            responseType: 'blob',
            ignoreLoadingBar: true
        }).then((response) => {
            return this.fileSaver.saveAs(new Blob([response.data], {type: response.headers('content-type')}), 'VouchersOverview.pdf');
        });
    }

    printVouchersOverviewDocument(invoice) {
        return this.api.post(`vouchers/overview-document/invoice/${invoice.id}/print`);
    }

    printInvoice(invoice) {
        return this.api.post(`billing/invoices/${invoice.id}/print`);
    }
}

/**
 * @ngdoc service
 * @name billing.invoices.services:InvoiceActionsService
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .factory('InvoiceActionsService', [
        '$uibModal',
        'FileSaver',
        '$http',
        ($uibModal, FileSaver, $http) => new InvoiceActionsService($uibModal, FileSaver, $http)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/services/invoice-actions-service.js